<!---
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -->

<template>
    <error-content
        code="404"
        desc="Oh~~您的页面好像飞走了~"
        :src="src"
    />
</template>

<script>
import error404 from '@/assets/images/error-page/error-404.svg';
import errorContent from './error-content.vue';
export default {
    name: 'Error404',
    components: {
        errorContent
    },
    data() {
        return {
            src: error404
        };
    }
};
</script>
